
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 19 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 0a8.99 8.99 0 00-7.36 3.82l1.22.868A7.489 7.489 0 0110 1.5c4.151 0 7.5 3.349 7.5 7.5s-3.349 7.5-7.5 7.5a7.493 7.493 0 01-6.14-3.188l-1.22.868A8.99 8.99 0 0010 18c4.963 0 9-4.037 9-9s-4.037-9-9-9zM4.492 5.46l-3 3L.977 9l.515.54 3 3 1.078-1.08-1.71-1.71H13v-1.5H3.86l1.71-1.71-1.078-1.08z"}})])
          )
        }
      }
    